define('model/settings.model',['require','exports','module','fukit'],function(require, exports, module) {
  // prettier-ignore
  var BaseModel              = require('fukit').BaseModel;

  var SettingsModel = BaseModel.extend({
    radioRequests: {
      'models SettingsModel': '@constructor',
    },

    useHalSelfLinkAsUrl: false,
    urlRoot: '/api/v2/coi/setting',

    virtual: {
      isAdminOnly: {
        deps: ['resolveAdminOnly'],
        get: function() {
          return this.get('resolveAdminOnly') === true;
        }
      },
      isAdminOrReviewer: {
        deps: ['resolveAdminOnly'],
        get: function() {
          return this.get('resolveAdminOnly') === false;
        },
      }
    }

  });

  module.exports = SettingsModel;
});

